import {
  Box,
  FormControlLabel,
  Stack,
  styled,
  Typography,
} from '@mui/material';

export const ProductListModalContainer = styled(Stack)`
  padding: 1rem 1.5rem;
  height: 70vh;
`;

export const ProductListModalHeader = styled(Stack)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 0.75rem;
`;

export const HeaderTitle = styled(Typography)(
  ({ theme }) => `
    font-weight: 400;
    font-size: 2.125rem;
    color: ${theme.palette.secondary.dark};
    `,
);

export const ProductListModalSubContainer = styled(Stack)`
  overflow-y: auto;
  height: 100%;
`;

export const ProductListModalFormControlLabel = styled(FormControlLabel)(
  ({ theme }) => `
  border-bottom: 1px solid ${theme.palette.secondary.lighter};
  `,
);

export const ButtonContainer = styled(Stack)`
  display: flex;
  height: 3.3125rem;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 1.55rem;
  gap: 0.625rem;
`;

export const ProductListModalResultContainer = styled(Stack)`
  padding: 1rem 0;
`;
export const ProductListModalContainerLabelName = styled(Box)`
  padding: 1rem;
`;
export const ProductListModalContainerLabel = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const HighlightedTextLabel = styled('span')(
  ({ theme }) => ` 
  background-color: ${theme.palette.primary.light};
  `,
);

export const StyledSearchBarWrapper = styled(Box)`
  width: 250px;
`;

export const ToggleExactMatch = styled(Box)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const InfoText = styled(Typography)(
  ({ theme }) => `
  color: ${theme.palette.secondary.light};
  font-size: 0.75rem;
  font-weight: 400px;
`,
);

export const SearchAndCloseIconWrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 1rem;
`;
